import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

/**
 * Tiny pill that surfaces offline status. It pops in when navigator.onLine
 * flips to false and pops back out when connection returns. Keeps the user
 * informed that recitations they've already opened are still available, while
 * progress saves are queued.
 */
export default function OfflineIndicator() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      data-testid="offline-indicator"
      className="fixed top-3 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-2 rounded-full bg-amber-900/90 border border-amber-500/40 backdrop-blur-md shadow-lg text-amber-100 text-xs font-outfit"
    >
      <WifiOff className="w-3.5 h-3.5" />
      <span>You're offline · cached pages still work</span>
    </div>
  );
}
